import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-set-detail-card',
  templateUrl: './message-set-detail-card.component.html',
  styleUrls: ['./message-set-detail-card.component.scss']
})
export class MessageSetDetailCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
